<template>
	<!-- <div class="router-view"> -->
		<el-breadcrumb separator-class="el-icon-arrow-right" separator=">" class="bread-m">
			<el-breadcrumb-item v-for="(item, index) in metaList" :key="index" :to="{ path: item.url,query: {order_uuid: item.order_uuid} }" class="bread-tab">
				<span :class="{ menuNow: index === metaList.length - 1 }">{{ item.name }}</span>
			</el-breadcrumb-item>
		</el-breadcrumb>
	<!-- </div> -->
</template>

<script>
	export default {
		data() {
			return {
				order_uuid: this.$route.query.order_uuid,
				metaList:this.$route.meta,
				pathData:{}
			};
		},

		created(){
			if(this.metaList && this.metaList.length){
				this.metaList.forEach((item,index)=>{
					if(item.url.indexOf("./order-detail") >-1  && item.name == "订单详情"){
						item.order_uuid = this.order_uuid;
					}
					else{
						item.order_uuid = '';
					}
				}) 
				console.log(this.metaList,"9989898")
			}
		}
	};
</script>

<style scoped>
    .bread-m{
        margin-bottom: 30px;
    }
	.router-view {
		margin-bottom: 20px;
		padding: 20px;
	}
    span{
       
       font-size: 14px;
       font-family: Microsoft YaHei;
       font-weight: 400;
        color: #9A9A9A;
    }
    .menuNow{
        color:rgba(52, 52, 52, 1)
    }
</style>
